import LlSelect from '@/components/LlSelect.vue';
export default {
  components: {
    LlSelect
  },
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    },
    offset: {
      type: Number,
      required: true
    },
    openDirection: {
      type: String,
      default: "bottom"
    }
  },
  computed: {
    initialPageValue() {
      if (this.offset === 0) {
        return 1;
      }
      return (this.currentPage - 1) * this.perPage;
    },
    offsetPageValue() {
      if (this.offset === 0) {
        return this.currentPage * this.perPage;
      }
      if (this.currentPage * this.perPage > this.totalItems) {
        return this.totalItems;
      }
      return this.currentPage * this.perPage;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    perPageOptions() {
      return [{
        label: 10,
        value: 10
      }, {
        label: 25,
        value: 25
      }, {
        label: 50,
        value: 50
      }, {
        label: 100,
        value: 100
      }];
    }
  },
  methods: {
    onClickPreviousPage() {
      this.$emit("pagechanged", this.currentPage - 1, this.perPage);
    },
    onClickNextPage() {
      this.$emit("pagechanged", this.currentPage + 1, this.perPage);
    },
    perPageChanged(newVal) {
      if (!newVal) {
        return;
      }
      this.$emit("pagechanged", this.currentPage, newVal);
    },
    perPageClosed() {
      this.$emit("pagechanged", this.currentPage, this.perPageOptions[0].value);
    }
  }
};